import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import {FiArrowRight, FiCalendar} from 'react-icons/fi';

const BOOKING_URL = 'https://links.myvoicelocal.com/widget/bookings/10-minute-call-with-stu';

const VSLStickyBar = () => {
  return (
    <motion.div
      initial={{y: 100}}
      animate={{y: 0}}
      transition={{delay: 1.5, type: 'spring', stiffness: 200}}
      className="fixed bottom-0 left-0 right-0 z-50 sm:hidden bg-[#faf8f5] border-t border-stone-200 px-4 py-3 shadow-2xl shadow-stone-900/20"
    >
      <div className="flex gap-3">
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 bg-stone-900 hover:bg-amber-700 text-white font-bold py-3.5 rounded-2xl text-sm flex items-center justify-center gap-1.5 transition-all shadow-lg shadow-stone-900/25"
        >
          Fast-Track ($997)
          <SafeIcon icon={FiArrowRight} className="text-xs" />
        </a>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 border border-stone-200 text-stone-700 font-bold py-3.5 rounded-2xl text-sm flex items-center justify-center gap-1.5 transition-all"
        >
          <SafeIcon icon={FiCalendar} className="text-xs" />
          Book Call
        </a>
      </div>
      <div className="flex justify-center mt-1.5">
        <div className="w-28 h-1 bg-stone-200 rounded-full" />
      </div>
    </motion.div>
  );
};

export default VSLStickyBar;